import api from './api';

export const remittanceService = {
  generate: (productIds: string[], quarter: number, year: number) => {
    return api.post('/remittances/generate', { productIds, quarter, year }, {
      responseType: 'blob',
    });
  },
};
